import React from 'react';
import ProductPage from '../components/product-page';
import ConnectorImage from '../components/connector-image';

export default function TouringPage() {
  return (
    <ProductPage
      title="Smart Distro Touring Panel"
      className="smart-power-theater"
      images={[
        {
          src: 'smart-distro-connector-view.png',
          alt: 'Portable box with different power connectors',
        },
        {
          src: 'smart-distro-breaker-view.png',
          alt: 'Panelboard built into rolling box',
        },
        {
          src: 'smart-distro-tablet.png',
          alt: 'Screenshot of web interface with metering and control',
        },
      ]}
      sections={[
        {
          title: 'Description',
          id: 'description',
          content: (
            <>
              Portable Power Distribution offering remote on/off circuit control
              via standard Wi-Fi using your Laptop, Tablet or Smart Phone.
            </>
          ),
        },
        {
          title: 'Features',
          id: 'features',
          content: (
            <ul>
              <li>Utilizes Eaton's remotely switchable circuit breakers.</li>
              <li>Metering on Mains (standard) and Circuits (optional).</li>
              <li>
                Built to Order - factory assembled and tested to your
                configuration.
              </li>
              <li>Optional Touchscreen for local control and monitoring.</li>
            </ul>
          ),
        },
        {
          title: 'Connectors',
          id: 'connectors',
          className: 'touring-connectors',
          content: (
            <>
              <ul>
                <li>
                  <ConnectorImage
                    src="camlok-male.png"
                    alt="Outline drawing of female Cam-Lok connector"
                  />
                  <h3>Cam-Lok</h3>
                  <span>input and pass-through, single or double neutrals</span>
                </li>
                <li>
                  <ConnectorImage
                    src="socapex.png"
                    alt="Outline drawing of female Socapex connector"
                  />
                  <h3>Socapex™</h3>
                  <span>SL419 Compatible, 120V and 208V</span>
                </li>
                <li>
                  <ConnectorImage
                    src="twistlock.png"
                    alt="white outline drawing of female Twist Lock connector"
                  />
                  <h3>Twist Lock</h3>
                  <span>120V and 208V</span>
                </li>
                <li>
                  <ConnectorImage
                    src="edison.png"
                    alt="white outline drawing of female Edison connector"
                  />
                  <h3>Edison</h3>
                  <span>optional GFI protection</span>
                </li>
                <li>
                  <ConnectorImage
                    src="powercon.png"
                    alt="white outline drawing of female PowerCON connector"
                  />
                  <h3>PowerCON</h3>
                  <span>120/240VAC, 20A</span>
                </li>
                <li>
                  <ConnectorImage
                    src="bates.png"
                    alt="white outline drawing of female Bates connector"
                  />
                  <h3>Bates</h3>
                  <span>120V and 208V</span>
                </li>
              </ul>
              <span>*Customer specified connectors available upon request</span>
            </>
          ),
        },
        {
          title: 'Specifications',
          id: 'specifications',
          content: (
            <>
              <table>
                <tbody>
                  <tr>
                    <th>Voltage Ratings</th>
                    <td>120/240V 1Ø 3W</td>
                    <td>208Y/120V 3Ø 4W</td>
                    <td>480Y/277V 3Ø 4W</td>
                  </tr>
                </tbody>
              </table>
              <table id="aic_ratings">
                <tbody>
                  <tr>
                    <th rowSpan="2">AIC Ratings</th>
                    <td className="left-align">
                      65kAIC@240V Fully Rated to 100kAIC Series Rated
                    </td>
                  </tr>
                  <tr>
                    <td className="left-align">
                      14kAIC@480Y/277V Fully Rated to 65kAIC Series Rated
                    </td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
              <table id="breaker_options">
                <tbody>
                  <tr>
                    <th rowSpan="3">Branch Circuit Breaker Options</th>
                    <td>1 Pole</td>
                    <td className="left-align">
                      Ratings: 15A, 20A, 30A Controlled, 15A to 100A
                      non-controlled
                    </td>
                  </tr>
                  <tr>
                    <td>2 Pole</td>
                    <td className="left-align">
                      Ratings: 15A, 20A, 30A Controlled, 15A to 100A
                      non-controlled
                    </td>
                  </tr>
                  <tr>
                    <td>3 Pole</td>
                    <td className="left-align">
                      Ratings: 15A to 100A non-controlled
                    </td>
                  </tr>
                </tbody>
              </table>
              <table id="main_options">
                <tbody>
                  <tr>
                    <th rowSpan="2">Mains Configurations</th>
                    <td>Lugs</td>
                    <td className="left-align">
                      Ratings: 1100A, 225A, 400A, and 600A Rated Connectors*:
                      Cam-Lok™ Single Pole Connectors
                    </td>
                  </tr>
                  <tr>
                    <td>Breaker</td>
                    <td className="left-align">60 Amps to 600 Amps</td>
                  </tr>
                </tbody>
              </table>
              <span>*Customer specified connectors available upon request</span>
              <table id="breaker_options">
                <tbody>
                  <tr>
                    <th rowSpan="6">Power Measurement</th>
                    <td>Mains Current Accuracy</td>
                    <td className="left-align">
                      1% of reading from 1% to 100% of nominal rated current
                    </td>
                  </tr>
                  <tr>
                    <td>Mains Voltage Accuracy</td>
                    <td className="left-align">
                      0.5% of reading from 90 to 600 VAC Line to Neutral
                    </td>
                  </tr>
                  <tr>
                    <td>Mains Power Data</td>
                    <td className="left-align">
                      Voltage, Current, Watts, PF, VA, VAR, HZ, WHrs, VAHrs,
                      VARHrs
                    </td>
                  </tr>
                  <tr>
                    <td>Branch Current Accuracy</td>
                    <td className="left-align">
                      1% of reading from 0.15 Amps to 100 Amps
                    </td>
                  </tr>
                  <tr>
                    <td>Branch Circuit Data</td>
                    <td className="left-align">
                      Current, Watts, PF, VA, VAR, WattHrs, VAHrs, VARHrs
                    </td>
                  </tr>
                  <tr>
                    <td>Data Update Rate</td>
                    <td className="left-align">
                      1 second for all real-time values
                    </td>
                  </tr>
                </tbody>
              </table>
              <table id="communications">
                <tbody>
                  <tr>
                    <th>Communications</th>
                    <td className="left-align">
                      DMX-512, Modbus 485, Modbus TCP/IP, Bacnet IP, Web Server
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ),
        },
        {
          title: 'Downloads',
          id: 'downloads',
          content: (
            <ul style={{ listStyle: 'none' }}>
              <li>
                <a href="/downloads/smart-distro-cut-sheet.pdf">
                  Product Sheet
                </a>
              </li>
              <li>
                <a href="/downloads/smart-distro-configuration-guide.pdf">
                  Configuration Guide
                </a>
              </li>
            </ul>
          ),
        },
      ]}
    />
  );
}
